import { TeamMembersRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

/** The row-kind filter this route adds on top of any params it passes through. */
type TeamMembersSearch = {
  /**
   * Preselects the row-kind filter (the "Show" dropdown), so a link can open
   * the page already scoped to pending join requests or guests.
   */
  type?: 'join-request' | 'guest';
};

export const Route = createFileRoute('/_authenticated/settings/team/')({
  component: TeamMembersRoute,
  // validateSearch replaces this route's search, so spread the incoming params
  // to preserve global ones the page doesn't own (masq_account_id, cmd-search,
  // …, all read from window.location) and only refine `type`.
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & TeamMembersSearch => ({
    ...search,
    type: search.type === 'join-request' || search.type === 'guest' ? search.type : undefined,
  }),
});
